/**
 * @flow
 * @relayHash 22f30f4d65a3ce75e5d56c143d752523
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CanonicalIssuesTable_project$ref = any;
export type canonical_CanonicalCategory_CanonicalIssuesTable_QueryVariables = {|
  host: string
|};
export type canonical_CanonicalCategory_CanonicalIssuesTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: CanonicalIssuesTable_project$ref
  |}
|};
export type canonical_CanonicalCategory_CanonicalIssuesTable_Query = {|
  variables: canonical_CanonicalCategory_CanonicalIssuesTable_QueryVariables,
  response: canonical_CanonicalCategory_CanonicalIssuesTable_QueryResponse,
|};
*/


/*
query canonical_CanonicalCategory_CanonicalIssuesTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...CanonicalIssuesTable_project
    id
  }
}

fragment CanonicalIssuesTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesCanonicalIssues(canonicalUrl: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {
          type
          severity
          count
        }
        canonicalIssues(offset: 0, limit: 20, sourceUrl: {operator: AND, values: []}, canonicalUrl: {operator: AND, values: []}, typeFilters: []) {
          count
          edges {
            node {
              ...CanonicalIssuesRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment CanonicalIssuesRow_issue on CanonicalIssue {
  id
  type
  severity
  canonical_urls
  source_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v4 = {
  "kind": "Literal",
  "name": "canonicalUrl",
  "value": v3,
  "type": "TextFilters"
},
v5 = {
  "kind": "Literal",
  "name": "sourceUrl",
  "value": v3,
  "type": "TextFilters"
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "canonical_CanonicalCategory_CanonicalIssuesTable_Query",
  "id": null,
  "text": "query canonical_CanonicalCategory_CanonicalIssuesTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...CanonicalIssuesTable_project\n    id\n  }\n}\n\nfragment CanonicalIssuesTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesCanonicalIssues(canonicalUrl: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {\n          type\n          severity\n          count\n        }\n        canonicalIssues(offset: 0, limit: 20, sourceUrl: {operator: AND, values: []}, canonicalUrl: {operator: AND, values: []}, typeFilters: []) {\n          count\n          edges {\n            node {\n              ...CanonicalIssuesRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment CanonicalIssuesRow_issue on CanonicalIssue {\n  id\n  type\n  severity\n  canonical_urls\n  source_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "canonical_CanonicalCategory_CanonicalIssuesTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CanonicalIssuesTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "canonical_CanonicalCategory_CanonicalIssuesTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesCanonicalIssues",
                        "storageKey": "countTypesCanonicalIssues(canonicalUrl:{\"operator\":\"AND\",\"values\":[]},sourceUrl:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v4,
                          v5
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v6,
                          v7,
                          v8
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "canonicalIssues",
                        "storageKey": "canonicalIssues(canonicalUrl:{\"operator\":\"AND\",\"values\":[]},limit:20,offset:0,sourceUrl:{\"operator\":\"AND\",\"values\":[]},typeFilters:[])",
                        "args": [
                          v4,
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v2,
                          v5,
                          {
                            "kind": "Literal",
                            "name": "typeFilters",
                            "value": [],
                            "type": "[String]"
                          }
                        ],
                        "concreteType": "CanonicalIssueConnection",
                        "plural": false,
                        "selections": [
                          v8,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CanonicalIssueEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CanonicalIssue",
                                "plural": false,
                                "selections": [
                                  v9,
                                  v6,
                                  v7,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "canonical_urls",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v9
                    ]
                  }
                ]
              }
            ]
          },
          v9
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1cc42c17da9248d3e3a869130ead4e1d';
module.exports = node;
